<article>
    <h1 i18n>🚀 Step 2: Assessments</h1>

    <p i18n>
        In this step, you will receive information on how students can make use
        of GenAI for the assessments in your course.
    </p>

    <p i18n>
        After adding an assessment, you decide whether the use of GenAI is
        a problem in this context, based on the ILOs that are tested. If you
        consider the use of GenAI in the assessment a problem, the tool suggests
        alternatives.
    </p>

    <p i18n>
        Next, pick one or more intended learning outcomes that are assessed in
        this way and whose assessment could be affected by the use of GenAI.
    </p>

    <p i18n>
        Please select one type of assessment. You can add more below.
    </p>

    <div class="d-flex flex-column gap-4">
        @for (subForm of form.controls.assessments.controls; track $index) {
        <gr-assessment-subform
            [subFormId]="$index.toString()"
            [subForm]="subForm"
            (removeForm)="removeAssessment($index)"
        />
        }
        <div class="col-md-6 col-xl-4 g-3 d-flex align-items-center">
            <button
                class="btn btn-outline-dark d-flex flex-column"
                (click)="addAssessment()"
                aria-labelledby="add-assessment"
                title="Add assessment"
                i18n-title
            >
                <fa-icon
                    [icon]="faPlus"
                    aria-hidden="true"
                    focusable="false"
                ></fa-icon>
                <span id="add-assessment" i18n>Add assessment</span>
            </button>
        </div>
    </div>
</article>

<gr-nav-buttons [navButtons]="navButtons" />
